import { api } from '@general/ui-kit'

export const usersApi = {
  list: (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== '' && value != null)
    ).toString()
    return api.get(`/users${query ? `?${query}` : ''}`)
  },
  get:            (id)        => api.get(`/users/${id}`),
  create:         (data)      => api.post('/users', data),
  update:         (id, data)  => api.patch(`/users/${id}`, data),
  toggleActive:   (id)        => api.patch(`/users/${id}/active`),
  resetPassword:  (id, newPassword, requirePasswordChange = true) =>
    api.patch(`/users/${id}/password`, { newPassword, requirePasswordChange }),
  // Lifts a pending forced change without touching the password.
  waivePasswordChange: (id) => api.delete(`/users/${id}/password-change`),
  remove:         (id)        => api.delete(`/users/${id}`),
}

export const rolesApi = {
  list:        ()          => api.get('/roles'),
  permissions: ()          => api.get('/roles/permissions'),
  create:      (data)      => api.post('/roles', data),
  update:      (id, data)  => api.patch(`/roles/${id}`, data),
  remove:      (id)        => api.delete(`/roles/${id}`),
}
